import { useState, useEffect } from "react";
import { Row, Col, Tab, Table, Nav } from "react-bootstrap";
import styled from "styled-components";
// assets
import mushrooms from "../assets/svgs/mushrooms.svg";
// styles
import { body_text_style, heading2_style } from "../styles";
const schedule_section_style = {
  fontSize: "calc(10px + 0.50vw)",
  background: "#1E3533",
};
const nav_item_style = {
  marginRight: "2%",
};
const nav_link_style = {
  fontSize: "calc(12px + 0.75vw)",
  background: "#315653",
  borderRadius: "10px",
  color: "white",
};

// const table_body_style = {
//   color: "#22B573",
// };
const mushrooms_col_style = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};
const mushrooms_img_style = {
  width: "75%",
};
const FloatingImage = styled.img`
  width: 20vw;
  animation: floating 3s infinite;
  @keyframes floating {
    0% {
      transform: translate(0, 0px);
    }
    50% {
      transform: translate(0, 25px);
    }
    100% {
      transform: translate(0, -0px);
    }
  }
`;
// variables

// #########################################
// Mini-Components
// #########################################
let friday_schedule = (
  <Table>
    <tbody style={body_text_style}>
      <tr>
        <td>6:00 - 7:00 PM EST</td>
        <td>Check-In</td>
      </tr>
      <tr>
        <td>7:00 PM - 8:00 PM EST</td>
        <td>Opening Ceremony</td>
      </tr>
      <tr>
        <td>8:00 PM - 10:00 EST</td>
        <td>Team Building & Brainstorming</td>
      </tr>
      <tr>
        <td>10:00 PM EST</td>
        <td>Hacking Begins!</td>
      </tr>
    </tbody>
  </Table>
);
let saturday_schedule = (
  <p style={body_text_style} className="my-4">
    Workshops and Activities all day!
  </p>
);
let sunday_schedule = (
  <Table>
    <tbody style={body_text_style}>
      <tr>
        <td>10:00 AM EST</td>
        <td>Hacking Ends!</td>
      </tr>
      <tr>
        <td>10:00 AM - 11:00 PM EST</td>
        <td>Project Submissions Devpost + Video Demos</td>
      </tr>
      <tr>
        <td>11:00 PM - 2:00 PM EST</td>
        <td>Judging</td>
      </tr>
      <tr>
        <td>2:00 - 3:00 PM EST</td>
        <td>Closing Ceremony</td>
      </tr>
    </tbody>
  </Table>
);

let schedule_component = (
  <div style={schedule_section_style}>
    <h2 style={heading2_style}>Schedule</h2>
    <Tab.Container defaultActiveKey="friday">
      <div>
        <Nav>
          <Nav.Item style={nav_item_style}>
            <Nav.Link style={nav_link_style} eventKey="friday">
              Friday
            </Nav.Link>
          </Nav.Item>
          <Nav.Item style={nav_item_style}>
            <Nav.Link style={nav_link_style} eventKey="saturday">
              Saturday
            </Nav.Link>
          </Nav.Item>
          <Nav.Item style={nav_item_style}>
            <Nav.Link style={nav_link_style} eventKey="sunday">
              Sunday
            </Nav.Link>
          </Nav.Item>
        </Nav>
      </div>

      <Row>
        <Tab.Content style={{ marginTop: "4%" }}>
          <Tab.Pane eventKey="friday">{friday_schedule}</Tab.Pane>
          <Tab.Pane eventKey="saturday">{saturday_schedule}</Tab.Pane>
          <Tab.Pane eventKey="sunday">{sunday_schedule}</Tab.Pane>
        </Tab.Content>
      </Row>
    </Tab.Container>
  </div>
);

let desktop_version = (
  <div>
    <Row>
      <Col style={mushrooms_col_style}>
        <FloatingImage
          src={mushrooms}
          alt="mushrooms"
          style={mushrooms_img_style}
        />
        {/* <img src={mushrooms} alt="mushrooms" style={mushrooms_img_style} /> */}
      </Col>

      <Col>{schedule_component}</Col>
    </Row>
  </div>
);
let mobile_version = <Row>{schedule_component}</Row>;

// #########################################
// Component
// #########################################
const ScheduleSection = () => {
  // conditional rendering
  const [isDesktop, setDesktop] = useState(window.innerWidth > 960);
  const updateMedia = () => {
    setDesktop(window.innerWidth > 960);
  };
  useEffect(() => {
    window.addEventListener("resize", updateMedia);
    return () => window.removeEventListener("resize", updateMedia);
  });

  return <div>{isDesktop ? desktop_version : mobile_version}</div>;
};

export default ScheduleSection;
